import { createSlice } from '@reduxjs/toolkit';
import { fetchCurrencies } from '../currencies/currenciesSlice';
import { fetchNetworks } from '../networks/networksSlice';
import { callPreTransfer } from '../transfer/transferSlice';
import { payWithPayPal, payWithCreditCard } from '../transfer/transferSlice';
import { fetchTransferTypes } from '../transferTypes/transferTypesSlice';
import { checkError } from './errorHelper';

const initialState = {
  errorText: '',
  isError: false,
  isPopupBlocked: false,
};

const updateStandardError = (name) => (state, action) => {
  const error = checkError(action, name);
  state.errorText = error.text;
  state.isError = error.type === 'global';
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {},
  extraReducers: {
    [callPreTransfer.rejected]: (state) => {
      state.errorText = 'Something went wrong with setting up payment, please try again latter.';
      state.isError = true;
    },

    [payWithPayPal.rejected]: (state, action) => {
      if (action.error?.message === 'popup-blocked') {
        state.isPopupBlocked = true;
      } else {
        state.errorText = 'Payment failed, please try again latter.';
        state.isError = true;
      }
    },

    [payWithCreditCard.rejected]: (state, action) => {
      state.errorText = 'Payment failed, please try again latter.';
      state.isError = true;
    },
    [fetchNetworks.rejected]: updateStandardError('fetchNetworks'),
    [fetchNetworks.fulfilled]: (state, action) => {
      if (action.payload.length === 0) {
        const error = checkError(action, 'fetchNetworks');
        state.errorText = error.text;
        state.isError = error.type === 'global';
      }
    },
    [fetchTransferTypes.rejected]: updateStandardError('fetchTransferTypes'),
    [fetchCurrencies.rejected]: updateStandardError('fetchCurrencies'),

    RESET: (state) => {
      state.errorText = '';
      state.isError = false;
      state.isPopupBlocked = false;
    },
  },
});

export default loadingSlice.reducer;
